var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverageImp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_6927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2299 9.375H15.1037C15.2793 9.37497 15.4494 9.4366 15.5843 9.54912C15.7191 9.66165 15.8102 9.81794 15.8417 9.99075L17.0687 16.7408C17.0883 16.8488 17.084 16.9598 17.056 17.066C17.0281 17.1722 16.9771 17.2709 16.9068 17.3553C16.8365 17.4396 16.7485 17.5075 16.6491 17.5541C16.5497 17.6007 16.4412 17.6249 16.3314 17.625H1.66966C1.55696 17.6251 1.44569 17.5998 1.34411 17.551C1.24253 17.5022 1.15325 17.4311 1.08292 17.3431C1.01259 17.255 0.963004 17.1522 0.937856 17.0424C0.912708 16.9325 0.912641 16.8184 0.93766 16.7085L2.47216 9.9585C2.50989 9.79277 2.6028 9.64478 2.73566 9.53876C2.86851 9.43275 3.03344 9.37501 3.20341 9.375H6.72841",
    stroke: "#FBFBFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6048 1.125H14.7886C14.9516 1.12491 15.1102 1.17793 15.2404 1.27605C15.3705 1.37416 15.4652 1.51202 15.5101 1.66875L16.5818 5.41875C16.6137 5.53041 16.6193 5.64797 16.5981 5.76215C16.5768 5.87633 16.5294 5.98402 16.4594 6.07673C16.3895 6.16944 16.2989 6.24464 16.195 6.2964C16.091 6.34816 15.9764 6.37507 15.8603 6.375H2.16905C2.04888 6.37502 1.93046 6.34616 1.82377 6.29085C1.71708 6.23554 1.62524 6.1554 1.55599 6.05719C1.48674 5.95897 1.44211 5.84556 1.42584 5.72649C1.40958 5.60742 1.42217 5.48619 1.46255 5.373L2.80205 1.623C2.85405 1.47725 2.94986 1.35114 3.07634 1.26199C3.20283 1.17283 3.3538 1.12498 3.50855 1.125H6.35855",
    stroke: "#FBFBFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97832 6.375C6.72832 6.375 6.72832 7.5 6.72832 7.875V9.75C6.72853 10.5139 6.49544 11.2596 6.06024 11.8875C5.62503 12.5153 5.00848 12.9952 4.29307 13.263C4.15148 13.315 4.02888 13.4085 3.94126 13.5313C3.85364 13.6541 3.80508 13.8005 3.80192 13.9513C3.79876 14.1021 3.84115 14.2503 3.92355 14.3767C4.00595 14.503 4.12454 14.6016 4.26382 14.6595C5.78105 15.1733 7.37698 15.4155 8.97832 15.375C10.5797 15.4154 12.1756 15.1732 13.6928 14.6595C13.8321 14.6016 13.9507 14.503 14.0331 14.3767C14.1155 14.2503 14.1579 14.1021 14.1547 13.9513C14.1516 13.8005 14.103 13.6541 14.0154 13.5313C13.9278 13.4085 13.8052 13.315 13.6636 13.263C12.9484 12.9949 12.3322 12.5149 11.8973 11.8871C11.4624 11.2593 11.2295 10.5137 11.2298 9.75V7.875C11.2298 7.5 11.2298 6.375 11.9798 6.375",
    stroke: "#FBFBFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97949 6.375V16.5",
    stroke: "#FBFBFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1045 3.75C13.1045 4.16475 11.2572 4.5 8.97949 4.5C6.70174 4.5 4.85449 4.16475 4.85449 3.75",
    stroke: "#FBFBFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7325 11.625C11.7325 12.0397 10.429 12.375 8.98004 12.375C7.53104 12.375 6.22754 12.0397 6.22754 11.625",
    stroke: "#FBFBFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2295 8.625C11.2295 9.03975 10.2222 9.375 8.97949 9.375C7.73674 9.375 6.72949 9.03975 6.72949 8.625",
    stroke: "#FBFBFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97949 4.5V0.375",
    stroke: "#FBFBFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47949 1.875L8.97949 0.375L10.4795 1.875",
    stroke: "#FBFBFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_6927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageImp);
export default __webpack_public_path__ + "static/media/average-imp.f340e4dba067ae5062285499aa281e02.svg";
export { ForwardRef as ReactComponent };